import React, { Component } from 'react'
import { Table, Button } from 'antd'
import moment from 'moment'

import { files } from '@services/api'

import download from '@utils/download'

import { fileExt } from '@texts/files'

class Files extends Component<any> {
    state = { page: 1 }
    downloadFile = async file => {
        const downloadedFile = await files
            .assert(file.url)
            .then(res => new Blob([res.data], { type: fileExt[file.file_ext] }))
        download(downloadedFile)
    }

    render() {
        const { list, loading } = this.props
        const { page } = this.state
        const fileTypes = {
            signature: 'חתימה',
            doc: 'מסמך',
            cli_signature: 'חתימה לסוכן',
            commission: 'עמלה'
        }
        const columns = [
            {
                title: 'הורדה',
                key: 'download',
                width: 200,
                align: 'right',
                render: (_, record) => <Button onClick={() => this.downloadFile(record)}>הורד קובץ</Button>
            },
            {
                title: 'נוצר בתאריך',
                key: 'created_at',
                align: 'right',
                render: (_, record) => (
                    <div>
                        {record.created_at ? moment(record.created_at).format('HH:mm DD/MM/YY') : 'אין תאריך העלאה'}
                    </div>
                )
            },
            {
                title: 'סוג',
                key: 'type',
                align: 'right',
                render: (_, record) => <div>{fileTypes[record.type] ? fileTypes[record.type] : record.type}</div>
            },
            {
                title: 'שם הקובץ',
                key: 'file_name',
                align: 'right',
                render: (_, record) => <div>{record.file_name}</div>
            },
            {
                title: 'מזהה',
                key: 'id',
                align: 'right',
                render: (_, record) => <div>{record.id}</div>
            },
            {
                title: 'סיומת',
                key: 'file_ext',
                align: 'right',
                render: (_, record) => <div>{record.file_ext}</div>
            },
            {
                title: 'מחיקה',
                key: 'delete',
                width: 200,
                align: 'right',
                render: (_, record) => (
                    <>
                        {record.updated_by && record.type === 'doc' && (
                            <Button type="danger" onClick={() => this.props.deleteFile(record.id)}>
                                מחק קובץ
                            </Button>
                        )}
                    </>
                )
            }
        ]
        return (
            <Table
                className="center-table"
                style={{ width: '100%' }}
                rowKey="id"
                loading={loading}
                columns={columns}
                rowClassName={record => record.policy_id}
                dataSource={list.slice((page - 1) * 20, page * 20)}
                pagination={{
                    total: list.length,
                    pageSize: 20,
                    current: page,
                    hideOnSinglePage: true,
                    onChange: page => this.setState({ page })
                }}
            />
        )
    }
}

export default Files
